import { useState, useRef, useEffect } from "react";
import { Globe, Check, Loader2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const LanguageSwitcher = () => {
  const { lang, setLang, languages, loading } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const current = languages.find((l) => l.code === lang);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 text-xs text-neutral-300 hover:text-white px-2.5 py-1.5 rounded-full border border-white/10 hover:border-white/25 transition-colors"
        aria-label="Change language"
      >
        {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Globe className="h-3.5 w-3.5" />}
        <span className="hidden sm:inline">{current?.name || "English"}</span>
        <span className="sm:hidden uppercase">{lang}</span>
      </button>
      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-2 w-52 max-h-80 overflow-y-auto rounded-xl border border-[#27272A] bg-[#121212] shadow-2xl z-50 py-1"
        >
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-white/5 transition-colors ${
                l.code === lang ? "text-[#FF3B30] font-semibold" : "text-neutral-300"
              }`}
            >
              {l.name}
              {l.code === lang && <Check className="h-3.5 w-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
